import { ToggleGroup } from '@/components/ui/daisy';
import {
  FlashcardAnswerOption,
  FlashcardCorrection,
} from '../../typologies/flashcard/useFlashcardAnswer';
import { FlashcardOption } from './FlashcardOption';

type FlashcardAnswerBtnProps = {
  value: string;
  onChange: (value: FlashcardCorrection) => void;
  options: FlashcardAnswerOption[];
  disabled: boolean;
};

export const FlashcardAnswerBtn = ({
  value,
  onChange,
  options,
  disabled,
}: FlashcardAnswerBtnProps) => {
  return (
    <ToggleGroup
      value={value}
      onChange={selected => onChange(selected as FlashcardCorrection)}
      className="w-full gap-2.5 rounded-2xl px-4 py-6 flex justify-center flex-wrap"
    >
      {options.map(option => (
        <FlashcardOption
          key={option.value}
          option={option}
          disabled={disabled}
        />
      ))}
    </ToggleGroup>
  );
};
